import { render, staticRenderFns } from "./StudentAlternatePlacement.vue?vue&type=template&id=c721f936"
import script from "./StudentAlternatePlacement.vue?vue&type=script&lang=js"
export * from "./StudentAlternatePlacement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports